module.exports = __webpack_public_path__ + "static/media/Investment.7a152483.png";